import { jsx as p, jsxs as O } from "react/jsx-runtime";
import o from "react";
import u, { css as N } from "styled-components";
import { u as B } from "../chunks/useResponsive.abbd7f84.js";
import { R as P, B as V } from "../chunks/index.b09c00db.js";
import { RangoBrand as j } from "./Brand.js";
const Y = u.header.withConfig({
  displayName: "Container",
  componentId: "sc-dtg4p5-0"
})(["display:flex;align-items:center;width:100%;height:var(--size-12x);&,*{z-index:5;}position:", ";top:0;left:0;right:0;background:", ";border-radius:var(--border-radius-none);border-bottom:", ";", ""], ({
  fixed: t
}) => t ? "fixed" : "absolute", ({
  ghost: t,
  inverse: r
}) => t || r ? "transparent" : "var(--elements-bg-color-01)", ({
  ghost: t,
  inverse: r,
  fixed: g,
  $scrolling: s,
  opened: m
}) => t || r ? "none" : (g && s || m) && "var(--default-border-width) solid var(--elements-border-color)", ({
  ghost: t,
  inverse: r,
  responsive: g,
  opened: s
}) => (t || r) && g && N(["border-bottom:", ";background:", ";transition-property:background;transition-delay:var( ", " );transition-timing-function:", ";transition-duration:", ";"], s && "var(--default-border-width) solid var(--elements-border-color)", s ? (r || t) && s && "var(--elements-bg-color-01)" : "transparent", s ? "--duration-fast-01" : "--duration-moderate-02", s ? "var(--curve-expressive-entrance)" : " var(--curve-productive-exit)", s ? "var(--duration-moderate-02)" : "var(--duration-fast-01)")), G = u.div.withConfig({
  displayName: "Wrapper",
  componentId: "sc-dtg4p5-1"
})(["display:flex;width:100%;height:100%;align-items:center;height:var(--size-6x);padding:", ";position:relative;"], ({
  responsive: t
}) => t ? "0 var(--spacing-1_5x) 0 var(--spacing-3x)" : "0 var(--size-5x)"), W = u.div.withConfig({
  displayName: "NavContainer",
  componentId: "sc-dtg4p5-2"
})(["align-self:center;height:var(--size-5x);padding:0 var(--size-5x);display:flex;flex:1;"]), q = u.div.withConfig({
  displayName: "NavContainerMobile",
  componentId: "sc-dtg4p5-3"
})(["display:flex;width:100%;justify-content:flex-end;"]), $ = u.div.withConfig({
  displayName: "HeaderButtons",
  componentId: "sc-dtg4p5-4"
})(["display:flex;"]), F = u.div.withConfig({
  displayName: "HeaderButtonsMobile",
  componentId: "sc-dtg4p5-5"
})(["height:var(--size-12x);gap:var(--spacing-10x);border-top:var(--default-border-width) solid var(--color-grey-100);background-color:var(--elements-bg-color-01);display:flex;justify-content:flex-start;align-items:center;flex-shrink:0;padding:0 var(--spacing-3x);"]), J = u.div.withConfig({
  displayName: "Slot",
  componentId: "sc-dtg4p5-6"
})(["max-width:100%;min-width:-moz-available;min-width:-webkit-fill-available;min-width:fill-available;box-sizing:border-box;z-index:4;display:flex;align-items:flex-start;position:absolute;top:0;left:0;height:0;padding:", ";", " background-color:var(--elements-bg-color-01);transition-property:transform,height,top,visibility;transition-duration:var(--duration-slow-01);", ""], ({
  responsive: t
}) => t ? "0" : "var(--size-5x)", ({
  opened: t,
  responsive: r
}) => t && !r && "border-bottom: var(--default-border-width) solid var(--elements-border-color);", ({
  opened: t,
  responsive: r
}) => t ? N(["transition-timing-function:var(--curve-expressive-entrance);height:auto;min-height:var(--spacing-15x);transform:scaleY(1);opacity:1;top:73.5px;visibility:visible;", ""], r && N(["opacity:1;transform:scaleY(1);height:calc(100svh - 96px);transition-duration:var(--duration-slow-01);"])) : N(["transition-timing-function:var(--curve-productive-exit);opacity:0;transform:scaleY(0);visibility:hidden;", ""], r && N(["transform:scaleY(0);height:0svh;opacity:0;transition-timing-function:var(--duration-moderate-02);"]))), K = u.div.withConfig({
  displayName: "SlotMobile",
  componentId: "sc-dtg4p5-7"
})(["display:flex;flex-direction:column;justify-content:space-between;height:100%;width:100%;"]), Q = u.div.withConfig({
  displayName: "SlotMobileContent",
  componentId: "sc-dtg4p5-8"
})(["overflow-y:", ";height:100%;padding-top:var(--spacing-4x);"], ({
  opened: t
}) => t ? "auto" : "hidden"), i = {
  RESPONSIVE_ACTION: "responsive",
  OPENED_ACTION: "opened",
  SELECTED_CHILD: "navChildSelected",
  INVERSE_ACTION: "inverse",
  SCROLLING_ACTION: "scroll"
}, U = o.forwardRef(({
  children: t,
  showAction: r = !0,
  showNav: g = !0,
  opened: s = !1,
  responsive: m = !1,
  fixed: S = !1,
  brandProps: T,
  onMenuOpen: E,
  onResponsive: C,
  ...h
}, _) => {
  const I = [], f = B(1023), [{
    isInverse: R,
    isOpened: n,
    isResponsive: c,
    isScrolling: A,
    navSelectedIndex: y
  }, a] = o.useReducer((e, d) => {
    switch (d.type) {
      case i.RESPONSIVE_ACTION:
        return {
          ...e,
          isResponsive: d.isResponsive
        };
      case i.OPENED_ACTION:
        return {
          ...e,
          isOpened: d.isOpened
        };
      case i.INVERSE_ACTION:
        return {
          ...e,
          isInverse: d.isInverse
        };
      case i.SELECTED_CHILD:
        return {
          ...e,
          navSelectedIndex: d.navSelectedIndex
        };
      case i.SCROLLING_ACTION:
        return {
          ...e,
          isScrolling: d.isScrolling
        };
      default:
        throw new Error(`Action ${d.type} is not supported`);
    }
  }, {
    isOpened: s,
    isResponsive: m || f,
    isInverse: h.inverse,
    isScrolling: !1,
    navSelectedIndex: null
  });
  o.useEffect(() => a({
    type: i.INVERSE_ACTION,
    isInverse: h.inverse
  }), [h.inverse]), o.useEffect(() => {
    const e = () => {
      a({
        type: i.SCROLLING_ACTION,
        isScrolling: window.scrollY > 0
      });
    };
    return window.addEventListener("scroll", e), () => window.removeEventListener("scroll", e);
  }, []), o.useEffect(() => a({
    type: i.OPENED_ACTION,
    isOpened: s
  }), [s]), o.useEffect(() => {
    a({
      type: i.OPENED_ACTION,
      isOpened: n
    }), E && E(n);
  }, [n]), o.useEffect(() => {
    C && C(f), a({
      type: i.RESPONSIVE_ACTION,
      isResponsive: f || m
    });
  }, [f, m]), o.useEffect(() => {
    const e = () => {
      n && !f && setTimeout(() => {
        a({
          type: i.OPENED_ACTION,
          isOpened: !1
        });
      }, 50);
    };
    return window.addEventListener("resize", () => e()), () => window.removeEventListener("resize", () => e());
  }, [n, f]), o.useLayoutEffect(() => {
    var e, d;
    if (y !== null) {
      const b = document.getElementById("sub-menu"), l = b.querySelector("div"), v = (e = b.querySelector("div")) == null ? void 0 : e.childNodes[1];
      v && (v.itemSelected = !0, v.style.display = "flex"), c || ((d = l == null ? void 0 : l.childNodes) == null ? void 0 : d.length) >= 2 && (l == null || l.removeChild(l.childNodes[0]));
    }
  }, [y, c]);
  const x = () => o.Children.toArray(t).filter((e) => e.props.slot === "nav").map((e) => e.props.children).map((e) => (I.push(e), [o.cloneElement(e, {
    onClickChild: H,
    ...e.props
  })])), w = () => o.Children.toArray(t).filter((e) => e.props.slot === "buttons").map((e) => [o.cloneElement(e, {
    ...e.props
  })]), L = () => /* @__PURE__ */ p(W, { "data-testid": "rango-header-nav-desktop", children: g && x() }), D = () => /* @__PURE__ */ p(q, { "data-testid": "rango-header-nav-mobile", children: /* @__PURE__ */ p(P, { icon: n ? "CloseLine" : "HamburguerLine", size: V.LG, ariaLabel: "Botão de menu", onClick: () => {
    k(), a({
      type: i.OPENED_ACTION,
      isOpened: !n
    });
  } }) }), M = () => /* @__PURE__ */ O(K, { children: [
    /* @__PURE__ */ p(Q, { opened: n, children: x() }),
    r && /* @__PURE__ */ p(F, { "data-testid": "rango-header-buttons-mobile", children: w() })
  ] }), z = () => {
    if (y !== null && I.length)
      return I[0].props.children[y];
  }, H = (e, d, b) => {
    if (c)
      return;
    const l = e.currentTarget, v = l.parentNode.children[1];
    l.childNodes.length >= 1 && l !== v ? (v && (v.style.display = "none"), (!n || !b) && a({
      type: i.OPENED_ACTION,
      isOpened: !n
    }), b && a({
      type: i.SELECTED_CHILD,
      navSelectedIndex: d
    })) : n && a({
      type: i.OPENED_ACTION,
      isOpened: !n
    });
  }, k = () => {
    h.inverse && (!R && c && n ? setTimeout(() => {
      a({
        type: i.INVERSE_ACTION,
        isInverse: !0
      });
    }, 240) : setTimeout(() => {
      a({
        type: i.INVERSE_ACTION,
        isInverse: !1
      });
    }, 70));
  };
  return /* @__PURE__ */ p(Y, { "data-testid": "rango-header", responsive: c, opened: n, fixed: S, $scrolling: A, ref: _, "data-rango-component": "rango-header", "data-is-rango": !0, ...h, children: /* @__PURE__ */ O(G, { responsive: c, children: [
    /* @__PURE__ */ p(j, { ...T }),
    c ? D() : L(),
    /* @__PURE__ */ p(J, { opened: n, responsive: c, id: "sub-menu", "data-testid": "rango-header-slot", children: c ? M() : z() }),
    /* @__PURE__ */ p($, { "data-testid": "rango-header-buttons", children: r && !c && w() })
  ] }) });
});
U.displayName = "RangoHeader";
export {
  U as RangoHeader
};
